import React from 'react';
import { addWeekdays } from '../utils/date-utils';

export const useCalendarDates = (maxSelectableDate, apiPayload, extraDates, apiBlockDates, apiHolidays) => {
  const computedMinDate = React.useMemo(() => {
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    return addWeekdays(now,9);
  }, []);

  const computedMaxDate = React.useMemo(() => {
    if (maxSelectableDate instanceof Date) {
      return new Date(maxSelectableDate.getFullYear(), maxSelectableDate.getMonth(), maxSelectableDate.getDate());
    }

    if (apiPayload?.rangeEnd) {
      const parsed = new Date(apiPayload.rangeEnd);
      if (!isNaN(parsed)) {
        return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
      }
    }

    const now = new Date();
    now.setHours(0, 0, 0, 0);
    const targetMonthIndex = now.getMonth() + 5;
    const targetYear = now.getFullYear() + Math.floor(targetMonthIndex / 12);
    const targetMonth = targetMonthIndex % 12;

    return new Date(targetYear, targetMonth + 1, 0);
  }, [maxSelectableDate, apiPayload]);

  const extraDatesSet = React.useMemo(() => {
    return new Set(
      (extraDates || [])
        .map(e => (typeof e === 'string' ? e : e?.date || ''))
        .filter(Boolean)
    );
  }, [extraDates]);

  const reservedSet = React.useMemo(() => {
    const s = new Set();
    apiBlockDates?.forEach(d => { if (d) s.add(d); });
    extraDatesSet.forEach(d => { if (d) s.add(d); });
    return s;
  }, [apiBlockDates, extraDatesSet]);

  const holidaySet = React.useMemo(() => {
    const s = new Set();
    apiHolidays?.forEach(d => { if (d) s.add(d); });
    return s;
  }, [apiHolidays]);

  return { computedMinDate, computedMaxDate, reservedSet, holidaySet };
};
